import { combineReducers } from 'redux'
import * as types from '../../utils/actionTypes'
import { createReducer } from '../../utils/helpers'

const initialState = {
  config: {
    title: 'Angebot',
    path: 'angebot',
    selectionKey: 'client',
    component: 'Offer',
  },
  form: {
    intro: 'Bitte geben Sie Ihre Kontaktdaten ein:',
    submitButton: 'Angebot unverbindlich anfordern',
    confirmationTitle: 'Offerte angefordert',
    confirmationSubTitle: 'Glückwunsch, Ihre Offerte wird bearbeitet',
    confirmationDescription:
      'Glückwunsch, Ihre Offerte wird bearbeitet. Sie erhalten in Kürze eine E-Mail mit dem Download-Link. Damit können Sie die Richtofferte für Ihr zukünftiges Traumhaus einfach herunterladen und ausdrucken.',
    confirmationButton: 'jetzt Angebot ansehen',
  },
  prefill: {
    email: '',
    firstName: '',
    lastName: '',
    location: '',
    message: '',
    phone: '',
    street: '',
    streetNumber: '',
    zip: '',
  },
}

export const config = createReducer(initialState.config, {})

export const form = createReducer(initialState.form, {})

// Prefill
const setPrefill = (state, payload) => payload

export const prefill = createReducer(initialState.prefill, {
  [types.SET_OFFER_PREFILL]: setPrefill,
})

// Default Export
export default combineReducers({
  config,
  form,
  prefill,
})



// WEBPACK FOOTER //
// ./src/modules/offer/reducers.js